<template>
  <d-navbar-nav class="border-left flex-row">
    <div class="changelog"></div>

    <li class="nav-item dropdown" style="border-left:1px solid #e1e5eb;margin-right: 10px;">
      <a
        class="nav-link dropdown-toggle text-nowrap px-3"
        style="margin-top: 10px;"
        v-d-toggle.user-actions
      >
        <span class="d-none d-md-inline-block">{{ this.Name }}</span>
      </a>
      <d-collapse id="user-actions" class="dropdown-menu dropdown-menu-small">
        <d-dropdown-item href="/login" class="text-danger" @click.native="logOut()">
          <i class="material-icons text-danger">&#xE879;</i> Logout
        </d-dropdown-item>
      </d-collapse>
    </li>
  </d-navbar-nav>
</template>
<script>
import { mapState } from "vuex";
import storage from "../../../helpers/storage";
export default {
  data() {
    return {
      orgName: " ",
      Name: ""
    };
  },
  computed: mapState({
    email: state => state.auth.data.profile.email,
    isAuthenticated: state => state.auth.isAuthenticated,
    fetchName: state => state.dash.nameData
  }),
  mounted() {
    var orgNamePre = this.email;
    var regex = /(?<=@)[^.]+(?=\.)/g;
    var orgNamePost = orgNamePre.match(regex);
    this.orgName = orgNamePost;
  },
  methods: {
    logOut() {
      this.$store.commit("logout");
      analytics.track("Logged Out");
      storage.removeAll().then(() => {
        this.$router.push("/login");
      });
    }
  },
  created() {},
  mounted() {
    const ls = storage.get("manager");
    this.Name = ls.first_name + " " + ls.last_name;
  }
};
</script>

<style>
.nav-link:hover {
  cursor: pointer;
}
.dropdown-toggle::after {
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  margin-left: 12.255em;
  margin-top: -10px;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.changelog {
  display: flex;
  justify-content: center;
  align-items: center;
  zoom: 1.5;
}
</style>
